import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";

import { ApiError, api } from "@platform/core/api";

const resourceSchema = z.object({ resource: z.url({ protocol: /^https?$/ }) });

// The MCP URL that the apps connect to, or null where MCP sign-in is off and the API serves no
// metadata. The environment decides it, so it never goes stale.
export const mcpServerQueryOptions = queryOptions({
	queryKey: ["mcp-server"],
	queryFn: async () => {
		try {
			const metadata = await api.get("/platform/oauth/.well-known/oauth-protected-resource");
			return resourceSchema.parse(metadata).resource;
		} catch (error) {
			if (error instanceof ApiError && error.status === 404) return null;
			throw error;
		}
	},
	staleTime: Infinity,
});
